import React from "react";

export interface InputGroupButtonProps extends React.HTMLAttributes<HTMLSpanElement> {
  /**
   * Button element(s) to wrap
   */
  children?: React.ReactNode;
  /**
   * Optional inline style overrides
   */
  style?: React.CSSProperties;
}

/**
 * InputGroup.Button replacement for react-bootstrap.
 * Wraps buttons within an input group.
 */
const InputGroupButton: React.FC<InputGroupButtonProps> = ({ children, style = {}, className = '', ...props }) => {
  const baseStyle: React.CSSProperties = {
    display: 'flex',
    ...style,
  };

  return (
    <span className={`input-group-btn ${className}`.trim()} style={baseStyle} {...props}>
      {children}
    </span>
  );
};

export default InputGroupButton;